<template>
    <a-modal
        centered
        title="更改/分配销售"
        :visible="visible"
        @ok="on_ok"
        @cancel="on_cancel"
        :width="540"
        :confirmLoading="submitting"
        :after-close="after_close"
        :ok_text="user_id ? '确定' : '取消所选客户的跟进人'"
    >
        <div class="ids">已选择：{{ record.map((v) => v.name || "匿名").join("，") }}（共{{ record.length }}人）</div>

        <a-divider>将销售更改为</a-divider>

        <a-checkable-tag
            :checked="item.id == user_id"
            class="r-checkbox checkbox-tag"
            v-for="item in basic_data_user"
            @change="on_click(item)"
            :key="item.id"
            >{{ item.name }}</a-checkable-tag
        >

        <a-input placeholder="添加一句备注..." v-model="remark" v-if="user_id" />
    </a-modal>
</template>
<script>
    import basic_data from "../../../mixins/basic_data";
    export default {
        mixins: [basic_data],
        data() {
            return {
                user_id: null,
                submitting: false,
                visible: false,
                callback: null,
                remark: null,
                record: [],
            };
        },
        mounted() {
            this.load_basic_user();
        },
        created() {
            this.$event_bus.$on("visible_customer_distribute", (record, user_id, callback) => {
                this.visible = true;

                this.record = record;
                this.callback = callback;

                this.user_id = user_id;
            });
        },
        methods: {
            on_ok() {
                this.submitting = true;
                this.$http
                    .post(`/member/distribute`, {
                        user_id: this.user_id,
                        remark:this.remark,
                        member_ids: this.record.map((v) => v.id),
                    })
                    .then((res) => {
                        if (res.success) {
                            this.$message.success(res.message);
                            this.on_cancel();
                            if (this.callback) {
                                this.callback();
                            }
                        } else {
                            this.$error({
                                title: "失败",
                                centered: true,
                                content: res.message,
                            });
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.submitting = false;
                    });
            },
            after_close() {
                this.user_id = null;
                this.remark  = null
            },
            on_cancel() {
                this.visible = false;
            },
            on_click(e) {
                this.user_id = e.id;
            },
        },
    };
</script>
<style lang="less" scoped>
    .r-checkbox {
        cursor: pointer;
        margin-bottom: 12px;
    }
    .ids {
        font-size: 12px;
    }
</style>
